import { Component, OnInit, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MemberIndividualAssociationStore, IMemberAssociation } from 'src/app/common-page-components/stores/entities-store/member-association-store';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, filter, mergeMap, first, tap } from 'rxjs/operators';
import { Router, ActivationEnd, ActivatedRoute } from '@angular/router';
import { IMemberAssociations } from '../../../../../common-page-components/stores/entities-store/continental-associations-store';
import { tileLayer, latLng, marker, icon } from 'leaflet';
import { EntitiesStore } from 'src/app/common-page-components/stores/entities-store/entities-store.abstract';
import { CountryCombo } from '../../../../../common-page-components/stores/filters-store/filters-store';
import { CountryDependencyEntityStore } from '../../../../../common-page-components/stores/entities-store/country-dependency-entity-store';
import { MembersRouterInterceptorService } from '../../../services/members-router-interceptor.service';
import { ContinentalIndividualAssociationStore } from 'src/app/common-page-components/stores/entities-store/continental-individual-association-store';
import { RegionCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { environment } from '../../../../../../environments/environment';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';

@Component({
  selector: 'app-bootstrap-members-information',
  templateUrl: './bootstrap-members-information.component.html',
  styleUrls: ['./bootstrap-members-information.component.scss']
})
export class BootstrapMembersInformationComponent implements OnInit {

  /**
   * Configuration options of leaflet map
   *
   * @memberof BootstrapMembersInformationComponent
   */
  optionsMap = undefined;

  /**
   * Layers of map
   *
   * @memberof BootstrapMembersInformationComponent
   */
  layers = undefined;
  memberAssocationStore: EntitiesStore<any>;

  /**
   *
   * News of association and member
   * @type {Array<INews>}
   * @memberof BootstrapMembersInformationComponent
   */
  news:Array<INews>;
  constructor(http: HttpClient, injector: Injector, router: Router, route: ActivatedRoute, notify_route: MembersRouterInterceptorService) {
    const tmpParams = {noc:undefined};
    router.events.pipe(
      filter(a => a instanceof ActivationEnd),
      map((a: ActivationEnd) => a.snapshot.params),
      first(),
      tap(a=> Object.assign(tmpParams, a)),
      mergeMap(a=> new RegionCombo('','',http, new BehaviorSubject({})).requestData({},false).pipe(map(a=> a.items))),
      mergeMap(countries => {
        // Check if there's a country code or a continent for bind property to the store.
        if(isNaN(parseInt(tmpParams.noc, 10)) === false){
          this.memberAssocationStore =  new ContinentalIndividualAssociationStore(http, injector);
          return this.memberAssocationStore.requestData({Continent:tmpParams.noc}, false).pipe(tap(a=> tmpParams.noc = a.items[0].MaCode),
          mergeMap(a=>{
            this.configureMap();
            // tslint:disable-next-line:max-line-length
            return http.get(environment.news_api.continental_association.replace('replace_id', a.items[0].CaId))
                  .pipe(tap((news:any)=> this.news = news), map(news=> a));
          }));
        } else{
          if(countries.findIndex(value=> value.CaCode.toLowerCase() === tmpParams.noc.toLowerCase())>-1){

            this.memberAssocationStore =  new ContinentalIndividualAssociationStore(http, injector);
            const caId = countries.find(value=> value.CaCode.toLowerCase() === tmpParams.noc.toLowerCase()).CaId;
            // tslint:disable-next-line:max-line-length
            return this.memberAssocationStore.requestData({Continent:caId}, false).pipe(
              mergeMap(a=>{
                this.configureMap();
                // tslint:disable-next-line:max-line-length
                return http.get(environment.news_api.continental_association.replace('replace_id', a.items[0].CaId))
                      .pipe(tap((news:any)=> this.news = news), map(news=> a));
              })
            );
          } else{
            this.memberAssocationStore = new MemberIndividualAssociationStore(http, injector);
            return this.memberAssocationStore.requestData({Noc:tmpParams.noc}, false).pipe(
              mergeMap(a=>{
                this.configureMap();
                // tslint:disable-next-line:max-line-length
                return http.get(environment.news_api.member.replace('replace_id', a.items[0].MaCode))
                      .pipe(tap((news:any)=> this.news = news), map(news=> a));
              })
            );
          }

        }
      }),
      tap(a=> {
          // tslint:disable-next-line:max-line-length
          /*const url = router.createUrlTree(['/member', tmpParams.noc.toLowerCase(), a.items[0].MaName.toLowerCase().replace(/ /g, '-')], {relativeTo: route, skipLocationChange: true});
          router.navigateByUrl(url);*/
      })
      ).subscribe();
  }

  /**
   * A Method for set map values and coordinates when data arrives
   *
   * @memberof BootstrapMembersInformationComponent
   */
  configureMap(){
    this.memberAssocationStore.dataStream.asObservable()
    .pipe(
      filter(a=>a != null),
      first(),
    )
    .subscribe(next=>{
        if(next[0] && next[0].Address.Latitude !== undefined){
        this.optionsMap={
          layers: [
            tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' })
          ],
          zoom: 15,
          center: latLng(next[0].Address.Latitude, next[0].Address.Longitude)
        };
        this.layers = [

          marker([next[0].Address.Latitude, next[0].Address.Longitude], {
            icon: icon({
              iconSize: [25, 41],
              iconAnchor: [13, 41],
              iconUrl: '../../../../../../modules/custom/wa_angular/app/assets/marker-icon.png',
              shadowUrl: '../../../../../../modules/custom/wa_angular/app/assets/marker-shadow.png'
            })
          }
          )
        ];
      }
    }
  );
  }

  ngOnInit() {
  }

  /**
   * A getter for bind the property of data into this view
   *
   * @readonly
   * @type {Observable<IMemberAssociation>}
   * @memberof BootstrapMembersInformationComponent
   */
  get data(): Observable<IMemberAssociation> {
    return this.memberAssocationStore.observableData.pipe(filter(a => a != undefined), map(a => a[0]));
  }

  /**
   * A method for get always an Array of emails if there's any
   *
   * @param {IMemberAssociation} member
   * @returns
   * @memberof BootstrapMembersInformationComponent
   */
  provideEmail(member: IMemberAssociation) {
    return member.Links["E-Mail"] instanceof Array ? member.Links["E-Mail"] : [member.Links["E-Mail"]]
  }

  /**
   * A method to provide the Array of telephones
   *
   * @param {IMemberAssociation} member
   * @returns
   * @memberof BootstrapMembersInformationComponent
   */
  provideTelephone(member: IMemberAssociation) {
    return [member.Links.Phone].concat(member.Links.Mobile).filter(a => a !== undefined);
  }

}
